export const MOUSE_EVENTS = [
  'onClick',
  'onContextMenu',
  'onDoubleClick',
  'onDrag',
  'onDragEnd',
  'onDragEnter',
  'onDragExit',
  'onDragLeave',
  'onDragOver',
  'onDragStart',
  'onDrop',
  'onMouseDown',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseMove',
  'onMouseOut',
  'onMouseOver',
  'onMouseUp',
];

// export const TWEENABLE_SVG_PRESENTATION_ATTRS = [
//   // 'alignmentBaseline',
//   // 'baselineShift',
//   // 'clip',
//   // 'clipPath',
//   // 'clipRule',
//   'color',
//   // 'colorInterpolation',
//   // 'colorInterpolationFilters',
//   // 'colorProfile',
//   // 'colorRendering',
//   // 'cursor',
//   // 'direction',
//   // 'display',
//   // 'dominantBaseline',
//   // 'enableBackground',
//   'fill',
//   'fillOpacity',
//   // 'fillRule',
//   // 'filter',
//   'floodColor',
//   'floodOpacity',
//   // 'fontFamily',
//   'fontSize',
//   'fontSizeAdjust',
//   'fontStretch',
//   // 'fontStyle',
//   // 'fontVariant',
//   // 'fontWeight',
//   // 'glyphOrientationHorizontal',
//   // 'glyphOrientationVertical',
//   // 'imageRendering',
//   'kerning',
//   'letterSpacing',
//   'lightingColor',
//   // 'markerEnd',
//   // 'markerMid',
//   // 'markerStart',
//   // 'mask',
//   'opacity',
//   // 'overflow',
//   // 'pointerEvents',
//   // 'shapeRendering',
//   'stopColor',
//   'stopOpacity',
//   'stroke',
//   // 'strokeDasharray',
//   'strokeDashoffset',
//   // 'strokeLinecap',
//   // 'strokeLinejoin',
//   'strokeMiterlimit',
//   'strokeOpacity',
//   'strokeWidth',
//   // 'textAnchor',
//   // 'textDecoration',
//   // 'textRendering',
//   // 'unicodeBidi',
//   // 'visibility',
//   'wordSpacing',
//   // 'writingMode',
// ];



// WEBPACK FOOTER //
// packages/util/src/constants.js